import { useEffect, useRef, type EffectCallback } from "react";

/**
 * A wrapper around the base React `useEffect` hook
 * that triggers an effect only on dependency updates, not on the initial mount.
 *
 * @param {Function} effect - The effect callback to run on updates.
 * @param {Array} dependencies - The list of dependencies that will trigger the effect when they change.
 */
function useUpdateEffect(effect: EffectCallback, dependencies: Array<unknown>) {
  const hasMounted = useRef(false);

  useEffect(() => {
    if (hasMounted.current) {
      return effect();
    }

    hasMounted.current = true;

    return undefined;
  }, dependencies);
}

export default useUpdateEffect;
